import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'

import { NavBase } from './Nav'

import {
  isAdminSelector,
  isPrexBusSelector,
  isDispatcherSelector,
  isCarrierSelector,
} from 'reduxModules/selectors/UserSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  isAdmin: isAdminSelector,
  isCarrier: isCarrierSelector,
  isPrexBus: isPrexBusSelector,
  isDispatcher: isDispatcherSelector,
})

const enhance = compose(
  connect(mapStateToProps),
  withStyles(styles)
)

export const Nav = enhance(NavBase)



// WEBPACK FOOTER //
// ./src/components/Nav/index.js